/*
axios 配置
 */
import axios from 'axios';
import router from '@/router';
import {Toast} from 'vant';
const service = axios.create({
  baseURL: '/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  }
})

service.interceptors.request.use(
    config => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.token = token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
)

service.interceptors.response.use(
    response => {
      // 增加文件判断
      if(response.headers['content-disposition']) {
        return Promise.resolve(response);
      }
      return Promise.resolve(response.data);
    },
    error => {
      if (error && error.response) {
        // 根据错误码跳转到对应的页面
        switch (error.response.status) {
          case 401:
            router.push('/error/401')
            break;
          case 404:
            Toast.error("请求不存在！");
            break;
          default:
            return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
      // let loading = Loading.service({ fullscreen: true })
      // loading.close();
    }
)

export default service;
